import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UsersResponse } from '../core/models/users.model';

/**
 * Editar perfil de usuario
 * @param http HttpClient instance
 * @param token User token
 * @param data User data
 * @returns Observable<any>
 */
export function editUserProfileApi(
  http: HttpClient,
  token: string,
  data: {
    name?: string;
    surname?: string;
    phone?: string;
    password?: string;
    notificationPush?: boolean;
    notificationEmail?: boolean;
  }
): Observable<any> {
  const url = `${environment.URL_API}/account`;
  const headers = { Authorization: `Bearer ${token}` };
  return http.patch<any>(url, data, { headers });
}

/**
 * Obtener datos de usuario
 * @param http HttpClient instance
 * @param token Authorization token
 * @returns Observable<any>
 */
export function getUserDataApi(
  http: HttpClient,
  token: string
): Observable<any> {
  const url = `${environment.URL_API}/account`;
  const headers = { Authorization: `Bearer ${token}` };
  return http.get<any>(url, { headers });
}

/**
 * Obtener lista de usuarios
 * @param http HttpClient instance
 * @param token Authorization token
 * @param queryParams
 * @returns Observable<any>
 */
export function getUsersListApi(
  http: HttpClient,
  token: string,
  queryParams: any = {}
): Observable<UsersResponse> {
  const params = new URLSearchParams(queryParams).toString();
  const baseUrl = `${environment.URL_API}/users`;
  const url = params ? `${baseUrl}?${params}` : baseUrl;
  const headers = { Authorization: `Bearer ${token}` };
  return http.get<UsersResponse>(url, { headers });
}

/**
 * Añadir usuario
 * @param http HttpClient instance
 * @param token Authorization token
 * @param data User data
 * @returns Observable<any>
 */
export function addUserApi(
  http: HttpClient,
  token: string,
  data: {
    name: string;
    surname: string;
    email: string;
    phone: string;
    capabilities: string[];
  }
): Observable<any> {
  const url = `${environment.URL_API}/users/add`;
  const headers = { Authorization: `Bearer ${token}` };
  return http.post<any>(url, data, { headers });
}

/**
 * Eliminar usuario
 * @param http HttpClient instance
 * @param token Authorization token
 * @param id User ID
 * @returns Observable<any>
 */
export function deleteUserApi(
  http: HttpClient,
  token: string,
  id: string
): Observable<any> {
  const url = `${environment.URL_API}/users/${id}`;
  const headers = { Authorization: `Bearer ${token}` };
  return http.delete<any>(url, { headers });
}

/**
 * Editar usuario
 * @param http HttpClient instance
 * @param token Authorization token
 * @param id User ID
 * @param data User data
 * @returns Observable<any>
 */
export function updateUserApi(
  http: HttpClient,
  token: string,
  id: string,
  data: {
    name?: string;
    surname?: string;
    phone?: string;
    capabilities?: string[];
  }
): Observable<any> {
  const url = `${environment.URL_API}/users/${id}`;
  const headers = { Authorization: `Bearer ${token}` };
  return http.patch<any>(url, data, { headers });
}

/**
 * Cambiar estado de usuario
 * @param http HttpClient instance
 * @param token Authorization token
 * @param id User ID
 * @returns Observable<any>
 */
export function toggleUserStatusApi(
  http: HttpClient,
  token: string,
  id: number
): Observable<any> {
  const url = `${environment.URL_API}/users/${id}/status`;
  const headers = { Authorization: `Bearer ${token}` };
  return http.patch<any>(url, {}, { headers });
}

/**
 * Establecer el proveedor por defecto
 * @param http HttpClient instance
 * @param token Authorization token
 * @param id Provider ID
 * @returns Observable<any>
 */
export function setDefaultTenantApi(
  http: HttpClient,
  token: string,
  id: number
): Observable<any> {
  const url = `${environment.URL_API}/account/provider/${id}`;
  const headers = { Authorization: `Bearer ${token}` };
  return http.patch<any>(url, {}, { headers });
}
